import { Layer } from '@deck.gl/core';
import {
  aerialTileLayer,
  aerialYears,
  archiveCuzkLayer,
  archiveYears,
  cuzkCirLayer,
  cuzkGeonamesWmsLayer,
  dmpLayer,
  dmrLayer,
  dmrMaleeSlope,
  dmrMaleeSlrm,
  dmrMaleeSRSlope,
  dmrMaleeSRSlrm,
  dmrZFactor10Layer,
  eagriLayer,
  esriArchiveYears,
  esriArchiveLayer,
  geoNamesLayer,
  geoNamesLayers,
  geologyLayer,
  geologyLayers,
  googleSatelliteLayer,
  historicalCeniaLayer,
  historicalMilitaryLayer,
  militaryHistoricalLayers,
  mineralResourcesLayer,
  mptSvpAerialLayer,
  mptSvpAerialYears,
  quadkeyTileLayer,
  quadkeyTileYears,
  transformedDmrMaleeSlrm,
  transformedDmrMaleeSlope,
} from '../layers';

export const layers: {
  [key: string]: {
    instances?: Layer[];
    constructors?: Array<() => Layer>;
  };
} = {
  base: { constructors: [() => aerialTileLayer(aerialYears.cuzkBase)] },
  dmr5g: { constructors: [() => dmrLayer()] },
  dmrzfactor10: { constructors: [() => dmrZFactor10Layer()] },
  // dmrMalee: { constructors: [() => dmrMaleeSlrm(), () => dmrMaleeSlope()] },
  dmrMalee: {
    constructors: [
      () => transformedDmrMaleeSlrm(),
      () => transformedDmrMaleeSlope(),
    ],
  },
  copernicus: {
    constructors: [() => geoNamesLayer(geoNamesLayers.gisco)],
  },
  aerialCuzk2025: {
    constructors: [
      () => aerialTileLayer(aerialYears.cuzk2023),
      () => geoNamesLayer(geoNamesLayers.gisco),
    ],
  },
  aerialCuzk2023: {
    constructors: [
      () => archiveCuzkLayer(archiveYears.cuzkArchive2023),
      () => geoNamesLayer(geoNamesLayers.gisco),
    ],
  },
  aerialCuzk2021: {
    constructors: [
      () => archiveCuzkLayer(archiveYears.cuzkArchive2021),
      () => geoNamesLayer(geoNamesLayers.gisco),
    ],
  },
  aerialCuzk2019: {
    constructors: [
      () => archiveCuzkLayer(archiveYears.cuzkArchive2019),
      () => geoNamesLayer(geoNamesLayers.gisco),
    ],
  },
  aerialCuzk2017: {
    constructors: [
      () => archiveCuzkLayer(archiveYears.cuzkArchive2017),
      () => geoNamesLayer(geoNamesLayers.gisco),
    ],
  },
  aerialCuzk2015: {
    constructors: [
      () => archiveCuzkLayer(archiveYears.cuzkArchive2015),
      () => geoNamesLayer(geoNamesLayers.gisco),
    ],
  },
  aerialCuzk2013: {
    constructors: [
      () => archiveCuzkLayer(archiveYears.cuzkArchive2013),
      () => geoNamesLayer(geoNamesLayers.gisco),
    ],
  },
  aerialCuzk2011: {
    constructors: [
      () => archiveCuzkLayer(archiveYears.cuzkArchive2011),
      () => geoNamesLayer(geoNamesLayers.gisco),
    ],
  },
  aerialMapy2023: {
    constructors: [
      () => aerialTileLayer(aerialYears.mapy2023),
      () => aerialTileLayer(aerialYears.mapySparse),
    ],
  },
  aerialCenia1950s: {
    constructors: [() => historicalCeniaLayer()],
  },
  mineralResources: {
    constructors: [
      () => aerialTileLayer(aerialYears.cuzk2023),
      () => geoNamesLayer(geoNamesLayers.gisco),
      () => mineralResourcesLayer(),
    ],
  },
  soilTypesLayer: {
    constructors: [
      () => geologyLayer(geologyLayers.soilTypes),
      () => geoNamesLayer(geoNamesLayers.gisco),
    ],
  },
  googleSatelliteMaps: {
    constructors: [
      () => googleSatelliteLayer(),
      () => geoNamesLayer(geoNamesLayers.gisco),
    ],
  },
  bingAerialMaps: {
    constructors: [
      () => quadkeyTileLayer(quadkeyTileYears.bingAerial),
      () => geoNamesLayer(geoNamesLayers.gisco),
    ],
  },
  aerialCuzkCir: {
    constructors: [
      () => cuzkCirLayer(),
      () => geoNamesLayer(geoNamesLayers.gisco),
    ],
  },
  dmp5g: { constructors: [() => dmpLayer()] },
  eagriLayer: {
    constructors: [
      () => eagriLayer(),
      () => cuzkGeonamesWmsLayer(),
    ],
  },
  zbgisSR: {
    constructors: [() => aerialTileLayer(aerialYears.zbgisSR)],
  },
  dmrMaleeSR: {
    constructors: [() => dmrMaleeSRSlrm(), () => dmrMaleeSRSlope()],
  },
  touristSRLayer: {
    constructors: [() => aerialTileLayer(aerialYears.touristSR)],
  },
  zbgisSROrto: {
    constructors: [() => aerialTileLayer(aerialYears.zbgisSROrto)],
  },
  aerialSR2023: {
    constructors: [() => mptSvpAerialLayer(mptSvpAerialYears.aerialSR2023)],
  },
  aerialSR2020: {
    constructors: [() => mptSvpAerialLayer(mptSvpAerialYears.aerialSR2020)],
  },
  aerialSR2016: {
    constructors: [() => mptSvpAerialLayer(mptSvpAerialYears.aerialSR2016)],
  },
  esriArchive2023: {
    constructors: [
      () => esriArchiveLayer(esriArchiveYears.esri2023),
      () => cuzkGeonamesWmsLayer(),
    ],
  },
  esriArchive2018: {
    constructors: [
      () => esriArchiveLayer(esriArchiveYears.esri2018),
      () => cuzkGeonamesWmsLayer(),
    ],
  },
  esriArchive2016: {
    constructors: [
      () => esriArchiveLayer(esriArchiveYears.esri2016),
      () => cuzkGeonamesWmsLayer(),
    ],
  },
  esriArchive2014: {
    constructors: [
      () => esriArchiveLayer(esriArchiveYears.esri2014),
      () => cuzkGeonamesWmsLayer(),
    ],
  },
  historicISurvey: {
    constructors: [
      () => historicalMilitaryLayer(militaryHistoricalLayers.firstMilitary),
    ],
  },
  historicIISurvey: {
    constructors: [
      () => historicalMilitaryLayer(militaryHistoricalLayers.secondMilitary),
    ],
  },
};

export const nullLayerLabel = 'Water map';

export const layerLabels: {
  [key: keyof typeof layers]: string;
} = {
  base: 'Base map',
  copernicus: 'Sentinel-2 latest',
  dmr5g: 'DMR 5G hillshade',
  dmp5g: 'DMP 5G',
  dmrMalee: 'DMR Malee.cz',
  dmrzfactor10: 'DMR 5G z-factor 10',
  aerialCuzk2025: 'CUZK 2025 aerial',
  aerialCuzk2023: 'CUZK 2023 aerial',
  aerialCuzk2021: 'CUZK 2021 aerial',
  aerialCuzk2019: 'CUZK 2019 aerial',
  aerialCuzk2017: 'CUZK 2017 aerial',
  aerialCuzk2015: 'CUZK 2015 aerial',
  aerialCuzk2013: 'CUZK 2013 aerial',
  aerialCuzk2011: 'CUZK 2011 aerial',
  aerialCuzkCir: 'CUZK CIR',
  aerialMapy2023: 'MapyCZ 2023 aerial',
  aerialCenia1950s: 'CENIA 1950s aerial',
  /*
  aerialMapy2018: 'MapyCZ 2018 aerial',
  aerialMapy2015: 'MapyCZ 2015 aerial',
  aerialMapy2012: 'MapyCZ 2012 aerial',
  aerialMapy2003: 'MapyCZ 2003 aerial',
  */
  eagriLayer: 'EAGRI 2025',
  googleSatelliteMaps: 'Google Satellite',
  bingAerialMaps: 'Bing Maps',
  zbgisSR: 'SR Base map',
  dmrMaleeSR: 'DMR SR Malee.cz',
  touristSRLayer: 'Tourist SR',
  zbgisSROrto: 'Orto SR',
  aerialSR2023: 'SR Orto 2023',
  aerialSR2020: 'SR Orto 2020',
  aerialSR2016: 'SR Orto 2016',
  esriArchive2023: 'ESRI 2023',
  esriArchive2018: 'ESRI 2018',
  esriArchive2016: 'ESRI 2016',
  esriArchive2014: 'ESRI 2014',
  soilTypesLayer: 'Soil types',
  mineralResources: 'Mineral Resources',
  historicISurvey: 'First military survey',
  historicIISurvey: 'Second military survey',
};
